/*
=============================================================================
BKNJ PDP MERCHANDISING — GIFT / ADD-ON CONTROLLER
Target Shopify file: assets/bknj-pdp-merchandising-gift-addon.js

Important:
- Gift qualification is strict: paid merchandise subtotal > normal gift price.
- Gift line is a separate zero-price twin product: normal-handle + "-gift".
- If two gift products are eligible, the customer chooses on the PDP; checkout is blocked until the customer
  explicitly chooses one.
=============================================================================
*/
(function(window, document){
  'use strict';

  if (window.BKNJGiftAddon && window.BKNJGiftAddon.version) return;

  var CONFIG_KEY = 'bknj_merch_offer_config_v2';
  var SELECTION_KEY = 'bknj_merch_offer_gift_choice_v2';
  var api = { version: '2.1.0' };
  var state = { syncBusy:false, checkoutBusy:false, config:null, lastCart:null, syncTimer:null, cartHookRegistered:false };

  function qs(selector, root){ return (root || document).querySelector(selector); }
  function qsa(selector, root){ return Array.prototype.slice.call((root || document).querySelectorAll(selector)); }
  function closest(el, selector){ return el && el.closest ? el.closest(selector) : null; }

  /* Keep opening/closing an overlay from changing the PDP's document scroll position.
     This matters on desktop Safari because the product info column is position:sticky. */
  function pageScrollY(){
    return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
  }

  function restorePageScroll(y){
    if (typeof y !== 'number' || !isFinite(y)) return;
    var current = pageScrollY();
    if (Math.abs(current - y) < 1) return;
    try { window.scrollTo({ top:y, left:0, behavior:'auto' }); }
    catch(error) { window.scrollTo(0, y); }
  }

  function focusWithoutScroll(el){
    if (!el || typeof el.focus !== 'function') return;
    try { el.focus({ preventScroll:true }); }
    catch(error) {
      var y = pageScrollY();
      try { el.focus(); } catch(ignore) {}
      restorePageScroll(y);
    }
  }

  function num(value){ var n = parseInt(value || '0', 10); return isNaN(n) ? 0 : n; }
  function prop(item, key){ return item && item.properties ? String(item.properties[key] == null ? '' : item.properties[key]) : ''; }

  function currentCurrency(){
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '';
  }

  function formatMoney(cents){
    cents = Number(cents || 0);
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      var format = window.BKNJ_CART_MONEY_FORMAT || window.money_format || (window.theme && window.theme.moneyFormat);
      if (format) return window.Shopify.formatMoney(cents, format);
    }
    var currency = currentCurrency() || 'USD';
    try { return (cents / 100).toLocaleString(undefined, { style:'currency', currency:currency }); }
    catch(error){ return (cents / 100).toFixed(2) + ' ' + currency; }
  }

  function readJSON(key, fallback){
    try { var raw = sessionStorage.getItem(key); return raw ? JSON.parse(raw) : fallback; }
    catch(error){ return fallback; }
  }

  function writeJSON(key, value){
    try { sessionStorage.setItem(key, JSON.stringify(value)); } catch(error) {}
  }

  function readChoice(){
    var data = readJSON(SELECTION_KEY, {});
    return data && data.slot ? String(data.slot) : '';
  }

  function writeChoice(slot){
    if (!slot) {
      try { sessionStorage.removeItem(SELECTION_KEY); } catch(error) {}
      return;
    }
    writeJSON(SELECTION_KEY, { slot:String(slot), source:'user', at:Date.now() });
  }

  function buildConfigFromPage(){
    var root = qs('[data-bknj-merch-offer]');
    if (!root) return null;

    var items = qsa('[data-bknj-offer-item]', root).map(function(el){
      var kind = el.getAttribute('data-kind') || '';
      var image = qs('.bknj-merch-offer__image img', el);
      var variantEl = qs('[data-bknj-addon-variant]', el);
      var variants = [];

      if (kind === 'addon' && variantEl) {
        if (variantEl.tagName && variantEl.tagName.toLowerCase() === 'select') {
          variants = Array.prototype.slice.call(variantEl.options).map(function(option){
            return { id:String(option.value), price:num(option.getAttribute('data-price')), available:option.getAttribute('data-available') === 'true', title:String(option.textContent || '').trim() };
          });
        } else {
          variants = [{ id:String(variantEl.value || ''), price:num(variantEl.getAttribute('data-price')), available:variantEl.getAttribute('data-available') === 'true', title:'' }];
        }
      }

      return {
        slot:String(el.getAttribute('data-slot') || ''),
        kind:kind,
        productId:String(el.getAttribute('data-product-id') || ''),
        handle:String(el.getAttribute('data-handle') || ''),
        title:String(el.getAttribute('data-title') || ''),
        url:String(el.getAttribute('data-url') || ''),
        image:image ? String(image.currentSrc || image.src || '') : '',
        priceCents:num(el.getAttribute('data-price')),
        formattedPrice:String(el.getAttribute('data-formatted-price') || ''),
        giftHandle:String(el.getAttribute('data-gift-handle') || ''),
        giftVariantId:String(el.getAttribute('data-gift-variant-id') || ''),
        giftAvailable:el.getAttribute('data-gift-available') === 'true',
        variants:variants
      };
    });

    var config = {
      version:1,
      currency:currentCurrency() || root.getAttribute('data-currency') || '',
      errorText:root.getAttribute('data-error-text') || 'Please select your complimentary gift before checkout.',
      savedAt:Date.now(),
      items:items
    };

    writeJSON(CONFIG_KEY, config);
    state.config = config;
    return config;
  }

  function getConfig(){
    if (state.config && state.config.items && state.config.items.length) return state.config;
    var fromPage = buildConfigFromPage();
    if (fromPage) return fromPage;
    var stored = readJSON(CONFIG_KEY, null);
    var activeCurrency = currentCurrency();
    if (stored && stored.currency && activeCurrency && String(stored.currency) !== String(activeCurrency)) {
      state.config = null;
      return null;
    }
    state.config = stored;
    return stored;
  }

  function fetchCart(){
    if (window.BKNJCart && typeof window.BKNJCart.fetch === 'function') return window.BKNJCart.fetch();
    return fetch('/cart.js', { credentials:'same-origin', headers:{'Accept':'application/json'} }).then(function(r){ if (!r.ok) throw new Error('Cart fetch failed'); return r.json(); });
  }

  function refreshCart(){
    if (window.BKNJCart && typeof window.BKNJCart.refresh === 'function') return window.BKNJCart.refresh();
    return fetchCart();
  }

  function addLine(variantId, properties){
    return fetch('/cart/add.js', {
      method:'POST', credentials:'same-origin', headers:{'Accept':'application/json','Content-Type':'application/json'},
      body:JSON.stringify({ items:[{ id:Number(variantId), quantity:1, properties:properties || {} }] })
    }).then(function(r){ if (!r.ok) return r.json().then(function(e){ throw e; }); return r.json(); });
  }

  function changeLine(key, quantity){
    return fetch('/cart/change.js', {
      method:'POST', credentials:'same-origin', headers:{'Accept':'application/json','Content-Type':'application/json'},
      body:JSON.stringify({ id:key, quantity:Number(quantity) })
    }).then(function(r){ if (!r.ok) return r.json().then(function(e){ throw e; }); return r.json(); });
  }

  function giftItems(config){ return (config && config.items ? config.items : []).filter(function(item){ return item.kind === 'gift' && item.giftAvailable && item.giftVariantId; }); }
  function addonItems(config){ return (config && config.items ? config.items : []).filter(function(item){ return item.kind === 'addon'; }); }

  function paidSubtotal(cart){
    return (cart && cart.items ? cart.items : []).reduce(function(total, item){
      return prop(item, '_bknj_gift') === '1' ? total : total + Number(item.final_line_price == null ? item.line_price || 0 : item.final_line_price);
    }, 0);
  }

  function eligibleGifts(config, cart){
    var subtotal = paidSubtotal(cart);
    return giftItems(config).filter(function(item){ return subtotal > Number(item.priceCents || 0); });
  }

  function cartGiftLines(cart){
    return (cart && cart.items ? cart.items : []).filter(function(item){ return prop(item, '_bknj_gift') === '1'; });
  }

  function cartAddonLine(cart, slot){
    return (cart && cart.items ? cart.items : []).find(function(item){ return prop(item, '_bknj_addon') === '1' && prop(item, '_bknj_offer_slot') === String(slot); });
  }

  function currentPdpVariantPrice(){
    var section = qs('.bknj-jh-product');
    if (!section) return 0;
    var idInput = qs('[data-bknj-variant-id]', section);
    var jsonEl = qs('[data-bknj-product-json]', section);
    if (!idInput || !jsonEl) return 0;
    try {
      var product = JSON.parse(jsonEl.textContent || '{}');
      var id = String(idInput.value || '');
      var variant = (product.variants || []).find(function(candidate){ return String(candidate.id || '') === id; });
      return variant ? Number(variant.price || 0) : 0;
    } catch(error) { return 0; }
  }

  function projectedPaidSubtotal(cart){
    return paidSubtotal(cart) + currentPdpVariantPrice();
  }

  function updatePdpGiftEligibility(cart){
    var config = getConfig();
    if (!config || !giftItems(config).length || !qs('.bknj-jh-product')) return;
    var projected = projectedPaidSubtotal(cart || {items:[]});
    var eligibleSlots = {};

    giftItems(config).forEach(function(item){
      eligibleSlots[String(item.slot)] = projected > Number(item.priceCents || 0);
    });

    qsa('[data-bknj-offer-item][data-kind="gift"]').forEach(function(item){
      var slot = String(item.getAttribute('data-slot') || '');
      var eligible = !!eligibleSlots[slot];
      item.setAttribute('data-eligible', eligible ? 'true' : 'false');
      item.classList.toggle('is-ineligible', !eligible);
      item.setAttribute('aria-disabled', eligible ? 'false' : 'true');
    });

    var selected = readChoice();
    if (selected && eligibleSlots[selected] === false) writeChoice('');
    updatePdpGiftChoice();
  }

  function getGiftDecision(config, cart){
    var eligible = eligibleGifts(config, cart);
    var selected = readChoice();

    // If the customer already has one of the valid gift lines in the cart,
    // treat that as the existing explicit choice even if sessionStorage was lost.
    if (!selected && cart) {
      var existingGift = cartGiftLines(cart).find(function(line){
        var slot = prop(line, '_bknj_offer_slot');
        return eligible.some(function(item){ return String(item.slot) === String(slot); });
      });
      if (existingGift) {
        selected = prop(existingGift, '_bknj_offer_slot');
        if (selected) writeChoice(selected);
      }
    }

    var selectedItem = eligible.find(function(item){ return String(item.slot) === String(selected); });

    if (eligible.length === 0) return { eligible:eligible, target:null, needsChoice:false };
    if (selectedItem) return { eligible:eligible, target:selectedItem, needsChoice:false };

    // Any eligible gift now requires an explicit customer choice before the
    // paid product may be added. This applies even when only one gift qualifies.
    return { eligible:eligible, target:null, needsChoice:true };
  }

  function removeGiftLinesExcept(cart, targetSlot){
    var lines = cartGiftLines(cart).filter(function(item){ return !targetSlot || prop(item, '_bknj_offer_slot') !== String(targetSlot); });
    var chain = Promise.resolve(cart);
    lines.forEach(function(item){
      chain = chain.then(function(){ return changeLine(item.key, 0); });
    });
    return chain;
  }

  function ensureTargetGift(cart, target){
    if (!target) return removeGiftLinesExcept(cart, '');

    return removeGiftLinesExcept(cart, target.slot).then(function(updated){
      var currentCart = updated && updated.items ? updated : cart;
      var existing = cartGiftLines(currentCart).find(function(item){ return prop(item, '_bknj_offer_slot') === String(target.slot); });

      if (existing) {
        if (Number(existing.quantity || 0) === 1) return currentCart;
        return changeLine(existing.key, 1);
      }

      return addLine(target.giftVariantId, {
        '_bknj_gift':'1',
        '_bknj_offer_slot':String(target.slot),
        '_bknj_gift_source_handle':target.handle,
        '_bknj_gift_display_title':target.title,
        '_bknj_gift_normal_price':String(target.priceCents || 0)
      }).then(function(){ return fetchCart(); });
    });
  }

  function setPdpMessage(text){
    qsa('[data-bknj-offer-message]').forEach(function(el){ el.textContent = text || ''; });
  }

  function updatePdpGiftChoice(){
    var choice = readChoice();
    var giftCards = qsa('[data-bknj-offer-item][data-kind="gift"]');

    giftCards.forEach(function(item){
      var slot = String(item.getAttribute('data-slot') || '');
      var eligible = item.getAttribute('data-eligible') !== 'false';
      var selected = !!(eligible && choice && String(choice) === slot);

      // Never auto-select a gift. The customer must click the card.
      item.classList.toggle('is-selected', selected);
      item.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
  }

  function updatePdpAddons(cart){
    qsa('[data-bknj-offer-item][data-kind="addon"]').forEach(function(item){
      var slot = item.getAttribute('data-slot') || '';
      var line = cartAddonLine(cart, slot);
      item.classList.toggle('is-added', !!line);
      item.setAttribute('aria-pressed', line ? 'true' : 'false');
    });
    updatePdpGiftEligibility(cart);
  }

  function cartDrawers(){ return qsa('#bknj-cart-drawer-d, #bknj-cart-drawer'); }


  function expressCheckoutBlocks(){
    return qsa('[data-bknj-cart-express-source], .bknj-cart-express');
  }

  function expressCheckoutAllowed(config, cart){
    if (!config || !giftItems(config).length) return true;
    if (!cart || !cart.items) return false;

    var decision = getGiftDecision(config, cart);
    if (decision.needsChoice) return false;
    if (!decision.target) return true;

    var lines = cartGiftLines(cart);
    return lines.length === 1 &&
      prop(lines[0], '_bknj_offer_slot') === String(decision.target.slot) &&
      Number(lines[0].quantity || 0) === 1;
  }

  function syncExpressCheckoutVisibility(cart){
    var config = getConfig();
    var allowed = expressCheckoutAllowed(config, cart);

    expressCheckoutBlocks().forEach(function(block){
      block.setAttribute('data-bknj-gift-blocked', allowed ? 'false' : 'true');
      var insideDrawer = !!closest(block, '#bknj-cart-drawer-d, #bknj-cart-drawer');
      if (!allowed) block.hidden = true;
      else if (insideDrawer) block.hidden = false;
    });

    return allowed;
  }

  function removeCartChoosers(){
    qsa('[data-bknj-cart-gift-chooser]').forEach(function(el){ el.remove(); });
  }

  function decorateGiftRows(cart){
    if (!cart || !cart.items) return;
    cartDrawers().forEach(function(drawer){
      var rows = qsa('.bknj-cart-item[data-key]', drawer);
      cart.items.forEach(function(item){
        if (prop(item, '_bknj_gift') !== '1') return;
        var row = rows.find(function(candidate){ return String(candidate.getAttribute('data-key') || '') === String(item.key || ''); });
        if (!row) return;

        row.classList.add('bknj-cart-item--gift');
        var displayTitle = prop(item, '_bknj_gift_display_title');
        var title = qs('.bknj-cart-title', row);
        var meta = qs('.bknj-cart-meta', row);
        if (title && displayTitle) title.textContent = displayTitle;
        if (meta) meta.textContent = 'Complimentary Gift';

        qsa('.bknj-cart-price', row).forEach(function(price){
          price.textContent = 'FREE';
          price.classList.add('bknj-cart-price--gift');
        });

        var actions = qs('.bknj-cart-actions', row);
        if (actions) {
          var lock = document.createElement('div');
          lock.className = 'bknj-cart-gift-lock';
          lock.setAttribute('aria-label', 'Complimentary gift quantity');
          lock.textContent = 'Qty 1';
          actions.replaceWith(lock);
        }
      });
    });
  }

  function showChoiceError(config, cart){
    var message = (config && config.errorText) || 'Please select your complimentary gift before checkout.';
    setPdpMessage(message);
    removeCartChoosers();

    // The gift choice belongs on the product page, not in the cart.
    // This alert is only a safeguard for bypass/manipulation cases where
    // checkout is attempted without a valid gift selection.
    try { window.alert(message); } catch(error) {}
  }

  function giftStateNeedsChange(cart, target){
    var lines = cartGiftLines(cart);
    if (!target) return lines.length > 0;
    if (lines.length !== 1) return true;
    return prop(lines[0], '_bknj_offer_slot') !== String(target.slot) || Number(lines[0].quantity || 0) !== 1;
  }

  function syncGifts(cart){
    var config = getConfig();
    if (!config || !giftItems(config).length) {
      removeCartChoosers();
      syncExpressCheckoutVisibility(cart);
      return Promise.resolve({ cart:cart, decision:{eligible:[],target:null,needsChoice:false}, changed:false });
    }

    var decision = getGiftDecision(config, cart);
    var changed = giftStateNeedsChange(cart, decision.target);
    return ensureTargetGift(cart, decision.target).then(function(updatedCart){
      if (changed) return fetchCart();
      return updatedCart && updatedCart.items ? updatedCart : cart;
    }).then(function(finalCart){
      decision = getGiftDecision(config, finalCart);
      state.lastCart = finalCart;
      updatePdpGiftChoice();
      updatePdpAddons(finalCart);
      removeCartChoosers();
      decorateGiftRows(finalCart);
      syncExpressCheckoutVisibility(finalCart);
      return { cart:finalCart, decision:decision, changed:changed };
    });
  }

  function runSync(){
    if (state.syncBusy) return Promise.resolve(null);
    state.syncBusy = true;
    return fetchCart()
      .then(function(cart){ state.lastCart = cart; return syncGifts(cart); })
      .then(function(result){
        if (result && result.changed && window.BKNJCart && typeof window.BKNJCart.refresh === 'function') {
          return window.BKNJCart.refresh().then(function(cart){ state.lastCart = cart; updatePdpAddons(cart); return result; });
        }
        return result;
      })
      .catch(function(){ return null; })
      .finally(function(){ state.syncBusy = false; });
  }

  function scheduleSync(delay){
    window.clearTimeout(state.syncTimer);
    state.syncTimer = window.setTimeout(function(){ runSync(); }, typeof delay === 'number' ? delay : 40);
  }

  function drawerForSlot(slot){
    return qsa('[data-bknj-offer-drawer]').find(function(drawer){ return String(drawer.getAttribute('data-slot') || '') === String(slot || ''); }) || null;
  }

  function portalDrawer(drawer){
    if (!drawer) return;
    window.clearTimeout(drawer.__bknjRestoreTimer);

    if (!drawer.__bknjPortalMarker && drawer.parentNode) {
      drawer.__bknjPortalMarker = document.createComment('bknj-merch-drawer-portal');
      drawer.parentNode.insertBefore(drawer.__bknjPortalMarker, drawer);
    }

    if (drawer.parentNode !== document.body) document.body.appendChild(drawer);
  }

  function restoreDrawer(drawer){
    if (!drawer) return;
    window.clearTimeout(drawer.__bknjRestoreTimer);
    drawer.__bknjRestoreTimer = window.setTimeout(function(){
      if (drawer.getAttribute('aria-hidden') === 'false') return;
      var marker = drawer.__bknjPortalMarker;
      if (marker && marker.parentNode) {
        marker.parentNode.insertBefore(drawer, marker);
        marker.parentNode.removeChild(marker);
      }
      drawer.__bknjPortalMarker = null;
    }, 580);
  }

  function syncDrawerGallery(drawer){
    if (!drawer) return;
    var media = qs('.bknj-merch-drawer__media', drawer);
    var slides = qsa('[data-bknj-offer-drawer-slide]', drawer);
    if (!media || !slides.length) return;

    var width = media.clientWidth || 1;
    var index = Math.round(media.scrollLeft / width);
    if (index < 0) index = 0;
    if (index > slides.length - 1) index = slides.length - 1;
    drawer.__bknjSlide = index;

    slides.forEach(function(slide, i){
      slide.hidden = false;
      slide.classList.toggle('is-active', i === index);
      slide.setAttribute('aria-hidden', i === index ? 'false' : 'true');
    });

    qsa('.bknj-merch-drawer__progress-dot', drawer).forEach(function(dot, i){
      dot.classList.toggle('is-active', i === index);
    });

    var current = qs('[data-bknj-offer-drawer-current]', drawer);
    if (current) current.textContent = String(index + 1);
  }

  function updateDrawerSlide(drawer, index, behavior){
    if (!drawer) return;
    var media = qs('.bknj-merch-drawer__media', drawer);
    var slides = qsa('[data-bknj-offer-drawer-slide]', drawer);
    if (!media || !slides.length) return;

    index = Number(index || 0);
    if (index < 0) index = slides.length - 1;
    if (index >= slides.length) index = 0;
    drawer.__bknjSlide = index;

    slides.forEach(function(slide){ slide.hidden = false; });

    var left = slides[index].offsetLeft;
    if (typeof media.scrollTo === 'function') {
      try { media.scrollTo({ left:left, behavior:behavior || 'smooth' }); }
      catch(error) { media.scrollLeft = left; }
    } else {
      media.scrollLeft = left;
    }

    window.requestAnimationFrame(function(){ syncDrawerGallery(drawer); });
  }

  function buildDrawerProgress(drawer){
    if (!drawer) return;
    var media = qs('.bknj-merch-drawer__media', drawer);
    var slides = qsa('[data-bknj-offer-drawer-slide]', drawer);
    if (!media || !slides.length) return;

    slides.forEach(function(slide){ slide.hidden = false; });

    var existing = qs('.bknj-merch-drawer__progress', drawer);
    if (slides.length <= 1) {
      if (existing) existing.remove();
      var navSingle = qs('.bknj-merch-drawer__media-nav', drawer);
      if (navSingle) navSingle.hidden = true;
      return;
    }

    var progress = existing;
    if (!progress) {
      progress = document.createElement('div');
      progress.className = 'bknj-merch-drawer__progress';
      progress.setAttribute('aria-hidden', 'true');
      media.insertAdjacentElement('afterend', progress);
    }

    progress.innerHTML = '';
    slides.forEach(function(_, i){
      var dot = document.createElement('span');
      dot.className = 'bknj-merch-drawer__progress-dot' + (i === 0 ? ' is-active' : '');
      progress.appendChild(dot);
    });

    var nav = qs('.bknj-merch-drawer__media-nav', drawer);
    if (nav) nav.hidden = false;
  }

  function closeDrawer(drawer){
    if (!drawer) return;
    var savedScrollY = typeof drawer.__bknjPageScrollY === 'number' ? drawer.__bknjPageScrollY : pageScrollY();

    drawer.setAttribute('aria-hidden', 'true');
    restoreDrawer(drawer);

    window.setTimeout(function(){
      var anyOpen = qsa('[data-bknj-offer-drawer]').some(function(candidate){ return candidate.getAttribute('aria-hidden') === 'false'; });
      if (!anyOpen) document.body.classList.remove('bknj-merch-drawer-open');
      restorePageScroll(savedScrollY);
    }, 560);

    focusWithoutScroll(drawer.__bknjReturnFocus);
    window.requestAnimationFrame(function(){ restorePageScroll(savedScrollY); });
  }

  function closeAllDrawers(){
    qsa('[data-bknj-offer-drawer]').forEach(function(drawer){
      if (drawer.getAttribute('aria-hidden') === 'false') closeDrawer(drawer);
    });
  }

  function openDrawer(slot, trigger){
    var drawer = drawerForSlot(slot);
    if (!drawer) return;

    /* Capture this before portaling or changing any overlay state. */
    var savedScrollY = pageScrollY();

    closeAllDrawers();
    portalDrawer(drawer);
    drawer.__bknjReturnFocus = trigger || null;
    drawer.__bknjPageScrollY = savedScrollY;
    document.body.classList.add('bknj-merch-drawer-open');
    drawer.setAttribute('aria-hidden', 'true');
    /* Establish the off-canvas start state after portaling so the .55s size-guide motion always runs. */
    try { void drawer.offsetWidth; } catch(error) {}
    drawer.setAttribute('aria-hidden', 'false');

    window.requestAnimationFrame(function(){
      restorePageScroll(savedScrollY);
      updateDrawerSlide(drawer, 0, 'auto');
    });

    var close = qs('.bknj-merch-drawer__close', drawer);
    if (close) window.setTimeout(function(){
      focusWithoutScroll(close);
      restorePageScroll(savedScrollY);
    }, 40);
  }

  function bindDrawer(drawer){
    if (!drawer || drawer.__bknjBound) return;
    drawer.__bknjBound = true;

    buildDrawerProgress(drawer);

    qsa('[data-bknj-offer-drawer-close]', drawer).forEach(function(button){
      button.addEventListener('click', function(){ closeDrawer(drawer); });
    });

    /* Desktop deliberately leaves the document scroll context untouched so the
       sticky PDP information never jumps. Prevent wheel/touch scrolling on the
       dimmed backdrop instead of changing body overflow. */
    var backdrop = qs('.bknj-merch-drawer__backdrop', drawer);
    if (backdrop) {
      backdrop.addEventListener('wheel', function(event){ event.preventDefault(); }, { passive:false });
      backdrop.addEventListener('touchmove', function(event){ event.preventDefault(); }, { passive:false });
    }

    var prev = qs('[data-bknj-offer-drawer-prev]', drawer);
    var next = qs('[data-bknj-offer-drawer-next]', drawer);
    if (prev) prev.addEventListener('click', function(event){
      event.preventDefault();
      event.stopPropagation();
      updateDrawerSlide(drawer, Number(drawer.__bknjSlide || 0) - 1, 'smooth');
    });
    if (next) next.addEventListener('click', function(event){
      event.preventDefault();
      event.stopPropagation();
      updateDrawerSlide(drawer, Number(drawer.__bknjSlide || 0) + 1, 'smooth');
    });

    var media = qs('.bknj-merch-drawer__media', drawer);
    if (media) {
      var raf = 0;
      media.addEventListener('scroll', function(){
        if (raf) window.cancelAnimationFrame(raf);
        raf = window.requestAnimationFrame(function(){
          raf = 0;
          syncDrawerGallery(drawer);
        });
      }, { passive:true });

      /* Desktop mouse drag. Touch devices keep native swipe / scroll-snap. */
      var dragging = false;
      var startX = 0;
      var startScroll = 0;

      media.addEventListener('pointerdown', function(event){
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        dragging = true;
        startX = event.clientX;
        startScroll = media.scrollLeft;
        media.classList.add('is-dragging');
        try { media.setPointerCapture(event.pointerId); } catch(error) {}
      });

      media.addEventListener('pointermove', function(event){
        if (!dragging) return;
        media.scrollLeft = startScroll - (event.clientX - startX);
      });

      function finishDrag(event){
        if (!dragging) return;
        dragging = false;
        media.classList.remove('is-dragging');
        try { media.releasePointerCapture(event.pointerId); } catch(error) {}
        var width = media.clientWidth || 1;
        var nearest = Math.round(media.scrollLeft / width);
        updateDrawerSlide(drawer, nearest, 'smooth');
      }

      media.addEventListener('pointerup', finishDrag);
      media.addEventListener('pointercancel', finishDrag);
      media.addEventListener('pointerleave', function(event){
        if (dragging && event.buttons === 0) finishDrag(event);
      });
    }

    syncDrawerGallery(drawer);
  }

  function selectOfferCard(item){
    if (!item || item.__bknjBusy) return;
    var kind = item.getAttribute('data-kind') || '';

    if (kind === 'gift') {
      if (item.getAttribute('data-eligible') === 'false' || item.classList.contains('is-ineligible')) {
        return;
      }
      var chosenSlot = item.getAttribute('data-slot') || '';
      qsa('[data-bknj-offer-item][data-kind="gift"]').forEach(function(card){
        var active = card === item;
        card.classList.toggle('is-selected', active);
        card.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      writeChoice(chosenSlot);
      setPdpMessage('');
      scheduleSync(0);
      return;
    }

    if (kind === 'addon') toggleAddon(item);
  }

  function selectedAddonVariant(item){
    var el = qs('[data-bknj-addon-variant]', item);
    if (!el) return null;
    if (el.tagName && el.tagName.toLowerCase() === 'select') {
      var opt = el.options[el.selectedIndex];
      return opt ? { id:String(opt.value), available:opt.getAttribute('data-available') === 'true' } : null;
    }
    return { id:String(el.value || ''), available:el.getAttribute('data-available') === 'true' };
  }

  function toggleAddon(item){
    if (!item || item.__bknjBusy) return;
    item.__bknjBusy = true;
    var slot = item.getAttribute('data-slot') || '';
    var variant = selectedAddonVariant(item);

    fetchCart().then(function(cart){
      var existing = cartAddonLine(cart, slot);
      if (existing) return changeLine(existing.key, 0);
      if (!variant || !variant.id || !variant.available) throw new Error('This option is unavailable.');
      return addLine(variant.id, { '_bknj_addon':'1', '_bknj_offer_slot':String(slot) }).then(function(){ return fetchCart(); });
    }).then(function(cart){
      state.lastCart = cart;
      updatePdpAddons(cart);
      return syncGifts(cart);
    }).then(function(){ return refreshCart(); })
      .catch(function(error){ setPdpMessage(error && error.description ? error.description : error.message || 'Something went wrong. Please try again.'); })
      .finally(function(){ item.__bknjBusy = false; });
  }

  function changeAddonVariant(item){
    var slot = item.getAttribute('data-slot') || '';
    fetchCart().then(function(cart){
      var existing = cartAddonLine(cart, slot);
      if (!existing) return cart;
      var variant = selectedAddonVariant(item);
      if (!variant || !variant.id || !variant.available) return changeLine(existing.key, 0);
      return changeLine(existing.key, 0).then(function(){ return addLine(variant.id, { '_bknj_addon':'1', '_bknj_offer_slot':String(slot) }); }).then(fetchCart);
    }).then(function(cart){ state.lastCart = cart; updatePdpAddons(cart); return syncGifts(cart); }).then(refreshCart).catch(function(){});
  }

  function bindPdp(){
    var root = qs('[data-bknj-merch-offer]');
    if (!root || root.__bknjOfferBound) return;
    root.__bknjOfferBound = true;
    buildConfigFromPage();

    var hasGift = giftItems(getConfig()).length > 0;
    var productSection = closest(root, '.bknj-jh-product');
    if (productSection) productSection.classList.toggle('bknj-offer-has-gift', hasGift);

    qsa('[data-bknj-offer-item]', root).forEach(function(item){
      item.addEventListener('click', function(event){
        if (closest(event.target, '[data-bknj-offer-view], select, option')) return;
        selectOfferCard(item);
      });
      item.addEventListener('keydown', function(event){
        if (event.key !== 'Enter' && event.key !== ' ') return;
        if (closest(event.target, 'select')) return;
        event.preventDefault();
        selectOfferCard(item);
      });
    });

    qsa('[data-bknj-offer-view]', root).forEach(function(button){
      button.addEventListener('click', function(event){
        event.preventDefault();
        event.stopPropagation();
        openDrawer(button.getAttribute('data-slot') || '', button);
      });
    });

    qsa('[data-bknj-offer-drawer]', root).forEach(bindDrawer);

    qsa('select[data-bknj-addon-variant]', root).forEach(function(select){
      select.addEventListener('click', function(event){ event.stopPropagation(); });
      select.addEventListener('change', function(event){
        event.stopPropagation();
        var item = closest(select, '[data-bknj-offer-item]');
        var opt = select.options[select.selectedIndex];
        var price = item ? qs('[data-bknj-offer-price]', item) : null;
        if (price && opt) price.textContent = formatMoney(num(opt.getAttribute('data-price')));
        if (item) changeAddonVariant(item);
      });
    });

    if (productSection && !productSection.__bknjOfferVariantWatch) {
      productSection.__bknjOfferVariantWatch = true;
      productSection.addEventListener('change', function(event){
        if (closest(event.target, '[data-bknj-merch-offer]')) return;
        window.setTimeout(function(){
          fetchCart().then(function(cart){ state.lastCart = cart; updatePdpGiftEligibility(cart); }).catch(function(){});
        }, 0);
      });
    }

    updatePdpGiftChoice();
    fetchCart().then(function(cart){ state.lastCart = cart; updatePdpAddons(cart); return syncGifts(cart); }).catch(function(){});
  }

  function validateProductAdd(){
    var config = getConfig();
    if (!config || !giftItems(config).length) return Promise.resolve({ allowed:true });

    return fetchCart().then(function(cart){
      state.lastCart = cart;
      updatePdpGiftEligibility(cart);

      var projected = projectedPaidSubtotal(cart);
      var eligible = giftItems(config).filter(function(item){
        return projected > Number(item.priceCents || 0);
      });

      // If this purchase does not qualify for any available gift, do not block Add to Bag.
      if (!eligible.length) {
        setPdpMessage('');
        return { allowed:true, cart:cart, eligible:eligible };
      }

      var selected = readChoice();

      // Preserve a valid gift already present in the cart as the customer's choice.
      if (!selected) {
        var existingGift = cartGiftLines(cart).find(function(line){
          var slot = prop(line, '_bknj_offer_slot');
          return eligible.some(function(item){ return String(item.slot) === String(slot); });
        });
        if (existingGift) {
          selected = prop(existingGift, '_bknj_offer_slot');
          if (selected) writeChoice(selected);
        }
      }

      var selectedItem = eligible.find(function(item){ return String(item.slot) === String(selected); });
      if (selectedItem) {
        setPdpMessage('');
        updatePdpGiftChoice();
        return { allowed:true, cart:cart, eligible:eligible, target:selectedItem };
      }

      var message = 'Please select your complimentary gift before adding to bag.';
      setPdpMessage(message);
      updatePdpGiftChoice();

      var firstEligible = qsa('[data-bknj-offer-item][data-kind="gift"]').find(function(card){
        return card.getAttribute('data-eligible') !== 'false';
      });
      if (firstEligible) {
        try { firstEligible.scrollIntoView({ behavior:'smooth', block:'center' }); } catch(error) {}
        try { firstEligible.focus({ preventScroll:true }); } catch(error) {}
      }

      return { allowed:false, reason:'gift-selection-required', message:message, cart:cart, eligible:eligible };
    }).catch(function(){
      // Fail closed when a gift campaign is active: never add the paid product
      // before the gift requirement has been validated.
      var message = 'Please select your complimentary gift before adding to bag.';
      setPdpMessage(message);
      return { allowed:false, reason:'gift-validation-failed', message:message };
    });
  }

  function isCheckoutTarget(target){
    return !!closest(target, 'a[href="/checkout"], a[href*="/checkout"], button[name="checkout"], input[name="checkout"], [data-cart-checkout], .bknj-cart__btn--primary');
  }


  function isExpressCheckoutTarget(target){
    return !!closest(target, '[data-bknj-cart-express], [data-bknj-cart-express-source], shop-pay-wallet-button, shopify-apple-pay-button, shopify-google-pay-button, shopify-paypal-button, shopify-amazon-pay-button');
  }

  function proceedToCheckout(){ window.location.assign('/checkout'); }

  function validateCheckout(){
    if (state.checkoutBusy) return;
    state.checkoutBusy = true;
    var config = getConfig();
    if (!config || !giftItems(config).length) { state.checkoutBusy = false; proceedToCheckout(); return; }

    fetchCart()
      .then(function(cart){
        state.lastCart = cart;
        var decision = getGiftDecision(config, cart);
        if (decision.needsChoice) {
          showChoiceError(config, cart);
          throw { bknjChoiceRequired:true };
        }
        return syncGifts(cart);
      })
      .then(function(result){
        if (result && result.decision && result.decision.needsChoice) {
          showChoiceError(config, result.cart);
          return;
        }
        proceedToCheckout();
      })
      .catch(function(error){
        if (!error || !error.bknjChoiceRequired) setPdpMessage('Please try checkout again.');
      })
      .finally(function(){ state.checkoutBusy = false; });
  }

  function bindCheckoutGuard(){
    if (document.__bknjGiftCheckoutBound) return;
    document.__bknjGiftCheckoutBound = true;

    document.addEventListener('click', function(event){
      if (isExpressCheckoutTarget(event.target)) {
        var expressConfig = getConfig();
        if (!expressConfig || !giftItems(expressConfig).length) return;
        if (expressCheckoutAllowed(expressConfig, state.lastCart)) return;

        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
        showChoiceError(expressConfig, state.lastCart || {items:[]});
        scheduleSync(0);
        return;
      }

      if (!isCheckoutTarget(event.target)) return;
      var config = getConfig();
      if (!config || !giftItems(config).length) return;
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
      validateCheckout();
    }, true);

    document.addEventListener('submit', function(event){
      var submitter = event.submitter || null;
      var form = event.target;
      var looksLikeCheckout = !!(submitter && (submitter.name === 'checkout' || isCheckoutTarget(submitter))) || !!(form && /\/checkout/.test(form.getAttribute('action') || ''));
      if (!looksLikeCheckout) return;
      var config = getConfig();
      if (!config || !giftItems(config).length) return;
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
      validateCheckout();
    }, true);
  }

  function cartEvent(event){
    if (event && event.detail && event.detail.cart) {
      state.lastCart = event.detail.cart;
      removeCartChoosers();
      decorateGiftRows(event.detail.cart);
      syncExpressCheckoutVisibility(event.detail.cart);
    }
    scheduleSync(40);
  }

  function afterProductAddHook(){
    var config = getConfig();
    if (!config || !giftItems(config).length) return Promise.resolve();
    return fetchCart()
      .then(function(cart){ state.lastCart = cart; return syncGifts(cart); })
      .then(function(result){ if (result && result.cart) decorateGiftRows(result.cart); })
      .catch(function(){ return null; });
  }

  function registerCartHook(){
    if (!window.BKNJCart || typeof window.BKNJCart.registerAfterProductAddHook !== 'function' || state.cartHookRegistered) return;
    state.cartHookRegistered = true;
    window.BKNJCart.registerAfterProductAddHook(afterProductAddHook);
  }

  /* Gift offer countdown, on the heading line. It swaps in for the plain heading while running
     and swaps back once the end time passes. */
  function bindOfferTimers(){
    qsa('[data-bknj-offer-timer]').forEach(function(timer){
      if (timer.__bknjTimerBound) return;
      var ends = Date.parse(timer.getAttribute('data-ends'));
      var value = qs('[data-bknj-offer-timer-value]', timer);
      var heading = qs('[data-bknj-offer-heading-default]', timer.parentNode);
      if (isNaN(ends) || !value) return;
      timer.__bknjTimerBound = true;

      function show(running){
        timer.hidden = !running;
        if (heading) heading.hidden = running;
      }
      function tick(){
        var left = Math.floor((ends - Date.now()) / 1000);
        if (left <= 0) { show(false); clearInterval(timer.__bknjTimerId); return; }
        var days = Math.floor(left / 86400);
        var hours = Math.floor(left % 86400 / 3600);
        var minutes = Math.floor(left % 3600 / 60);
        value.textContent = (days > 0 ? days + 'd ' : '') + (days > 0 || hours > 0 ? hours + 'h ' : '') + minutes + 'm';
        show(true);
      }

      tick();
      timer.__bknjTimerId = setInterval(tick, 15000);
    });
  }

  function init(){
    bindOfferTimers();
    var isPdp = !!qs('.bknj-jh-product');
    var hasOfferRoot = !!qs('[data-bknj-merch-offer]');

    if (isPdp && !hasOfferRoot) {
      state.config = null;
      try { sessionStorage.removeItem(CONFIG_KEY); sessionStorage.removeItem(SELECTION_KEY); } catch(error) {}
      removeCartChoosers();
    }

    bindPdp();
    bindCheckoutGuard();
    registerCartHook();

    if (!document.__bknjMerchDrawerEscapeBound) {
      document.__bknjMerchDrawerEscapeBound = true;
      document.addEventListener('keydown', function(event){
        if (event.key === 'Escape') closeAllDrawers();
      });
    }

    scheduleSync(80);
  }

  ['open','refresh','change'].forEach(function(name){ document.addEventListener('bknj:cart:' + name, cartEvent); });
  document.addEventListener('bknj:cart:ready', function(event){ registerCartHook(); cartEvent(event); });
  document.addEventListener('shopify:section:load', function(){ state.config = null; bindOfferTimers(); bindPdp(); scheduleSync(0); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  api.sync = runSync;
  api.getConfig = getConfig;
  api.validateProductAdd = validateProductAdd;
  api.version = '2.5.0-refined-product-drawer';
  window.BKNJGiftAddon = api;
})(window, document);
